import reactToBreakpoints from 'reactive-media-queries';
import { ref, computed, Ref } from '@vue/composition-api';

const currentBreakpoint: Ref<string> | Ref<null> = ref(null);
const tabletLayout = computed(() =>
  currentBreakpoint.value === 'phone' || currentBreakpoint.value === 'tablet',
);
const mobileLayout = computed(() =>
  currentBreakpoint.value === 'phone',
);
reactToBreakpoints({
  phone: 768,
  tablet: 1024,
  desktop: 1440,
  desktopXL: Infinity,
}, (key) => {
  currentBreakpoint.value = key;
});

export function useMQ () {
  return { currentBreakpoint, tabletLayout, mobileLayout };
}
